module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ThinItalic.ab7ae0af.ttf";